<template>
  <div>
    <back-route-hdr :back-mode="'func'" :cur-hash="'u-detail'"
                    @handle-back="handleBack()"></back-route-hdr>
    <!-- 参会人相关 -->
    <van-tabs v-show="tabList" class="mar-btm-10" v-model="activeTab" @click="changeTab">
      <van-tab v-for="ele in tabList" :key="ele.k"
               :title="ele.v" :name="ele.k">
      </van-tab>
    </van-tabs>

    <!-- 内部 -->
    <div v-show="isInner">
      <van-cell-group class="mar-operate-btm">
        <van-cell :title="`选择${sysFormTitles.insideParticipant}`" is-link
                  @click="handleBack('add')"></van-cell>
        <van-cell v-for="user in userData" :key="user.userId" center>
          <template #title>
            <span class="color-box mar-rgt-10"
                  :style="`background-color:rgba(${user.headerColor},0.35)`">{{user.name[0]}}</span>
            <span class="custom-title">{{user.name}}</span>
            <i v-show="user.ignoreNotice" class="fa fa-bell-slash-o text-danger mar-lft-10"></i>
          </template>
          <template #right-icon>
            <van-icon name="clear" class="text-md" @click="removeUser(user)"></van-icon>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <!-- 外部 -->
    <div v-show="!isInner">
      <input-visitor :cur-data="visitor" @change-data="visitor=$event"></input-visitor>
    </div>

    <div class="fixed-btm-box bord-top">
      <div class="pull-right pad-all-10">
        <van-button icon="arrow-left" size="small" @click="handleBack()">返回</van-button>
        <van-button v-show="hasChanged" type="primary" size="small" class="mar-lft-10"
                    @click="handleBack('users')">确定修改
        </van-button>
      </div>
      <!--<div class="pad-all">
        <span>原 {{insideParticipant.length}} 人，现 {{userData.length}} 人</span>
      </div>-->
    </div>


  </div>
</template>

<script>
  import {checkShowPermit, frontConfirm} from "../../../../../tools/utils";
  import InputVisitor from './InputVisitor.vue'

  export default {
    components: {
      InputVisitor,
    },
    props: {
      insideParticipant: Array,
      outsideParticipant: Array,
    },
    data() {
      return {
        activeTab: "inner",
        isInner: true,
        userData: [],
        visitor: [],
      }
    },
    computed: {
      sysFormTitles() {
        return this.$store.state.formTitles
      },
      tabList() {
        const arr = [{k: "inner", v: this.sysFormTitles.insideParticipant}];
        if (checkShowPermit(this.$store.state.permissionList || [], this.permitsMap.outsideParticipant)) {
          arr.push({k: "outer", v: this.sysFormTitles.outsideParticipant})
        }
        return arr
      },
      hasChanged() {
        return this.insideParticipant.length !== this.userData.length
          || JSON.stringify(this.visitor) !== JSON.stringify(this.outsideParticipant)
      }
    },
    created() {
      this.userData = [].concat(this.insideParticipant);
      this.visitor = [].concat(this.outsideParticipant);
    },
    methods: {
      changeTab(name) {
        // console.log(name);
        this.isInner = name === 'inner';
      },
      removeUser(user) {
        frontConfirm({
          title: "删除确认",
          msg: `是否确认删除${this.sysFormTitles.insideParticipant}-${user.name}？`,
        }, () => {
          const idx = this.userData.findIndex(e => e.userId === user.userId);
          this.userData.splice(idx, 1);
        })
      },
      handleBack(type) {
        let data;
        switch (type) {
          case 'add':
            data = {add: true, inner: this.userData, outer: this.visitor};
            break;
          case 'users':
            data = {inner: this.userData, outer: this.visitor};
            break;
          default:
        }
        this.$emit('change-info', data)
      },
    }
  }
</script>

<style scoped>
</style>
